import React from "react";
import { StyleSheet } from "react-native";
import { useIsFocused } from "@react-navigation/native";
import AnimateNumber from "react-native-animate-number";
import theme from "app/Theme/Theme";
import { Box, MainText } from "app/components/common";

const styles = StyleSheet.create({
  stat: {
    ...theme.body["l6-bold"],
    color: theme.colors["brand.500"],
  },
});

const ProfileStat = ({ stat, legend }) => {
  const isFocused = useIsFocused();

  return (
    <Box alignItems="center" justifyContent="center" flexDirection="column">
      <AnimateNumber
        maxFontSizeMultiplier={1.2}
        countBy={1}
        value={isFocused ? stat : 0}
        style={styles.stat}
      />
      <MainText variant="l3-medium" marginTop="xxs" color="neutral.600">
        {legend}
      </MainText>
    </Box>
  );
};

export default ProfileStat;
